import React from 'react'

export const OmitMeasures = () => <path d='M4 21V14M4 10V3M12 21V12M12 8V3M20 21V16M20 12V3M1 14H7M9 8H15M17 16H23' />
